/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_Guide_VideoInputs */

const vi_media_owner_guide_video = /** @type {(inputs: Media_Owner_Guide_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video hướng dẫn`)
};

/**

* @param {Media_Owner_Guide_VideoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_guide_video = /** @type {((inputs?: Media_Owner_Guide_VideoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_Guide_VideoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_guide_video(inputs)
});